import type { SelectItem } from "@cynthai/ui";

import { m } from "@/paraglide/messages";

import type { TimeRange } from "./date-time-ranges";

export const AUDIT_PROJECT_TYPE = "audit" as const;

export const AUDIT_CLIENT_PROJECT_TYPE = "audit_client" as const;

export const CORPORATE_FINANCE_PROJECT_TYPE = "corporate_finance" as const;

export const FAS_PROJECT_TYPE = "fas" as const;

export const DEFAULT_TIME_RANGE = "all-time" as const;

export const getTimeRangeOptions = (
  allTimeLabel: string,
): SelectItem<TimeRange>[] => [
  { value: "today", label: m.today_filter() },
  { value: "last-week", label: m.last_week_filter() },
  { value: "last-month", label: m.last_month_filter() },
  { value: "last-year", label: m.last_year_filter() },
  { value: "all-time", label: allTimeLabel },
];
